// extracted by mini-css-extract-plugin
export default {"cell":"cell_cell__SjOVx","sortable":"cell_sortable__dsvHU","active":"cell_active__KIiy2"};